import axios from 'axios';
import config from '../config-api.json';
import {
  GetSearchType,
  GetSearchParamType,
  GetRelatedWordType,
  GetRelatedWordParamType,
  GetPopularKeywordType,
  GetPopularKeywordParamType,
  GetWikiType,
  GetWikiParamType,
  GetSpellCheckerParamType,
  GetSpellCheckerType,
  GetSearchImageParamType,
  GetSearchImageType,
  GetSearchAttachParamType,
  GetSearchAttachResponseType,
} from './type';

const env = process.env.NODE_ENV;
let { apiInfo } = config;

if (env === 'development') {
  apiInfo = config.apiInfo_dev;
}

export async function apiGetSearch(info: GetSearchParamType) {
  const paramsData: GetSearchParamType = {
    page: info.page,
    page_count: info.page_count,
    session: info.session,
    targets: info.targets,
    query: info.query,
    type: info.type,
    search_option: info.search_option,
  };
  if (info.start_date && info.end_date) {
    paramsData.start_date = info.start_date;
    paramsData.end_date = info.end_date;
    const response = await axios.get<GetSearchType>(
      `${apiInfo.api_url}/search/`,
      {
        params: paramsData,
      }
    );

    return response.data;
  }
  const response = await axios.get<GetSearchType>(
    `${apiInfo.api_url}/search/`,
    {
      params: paramsData,
    }
  );

  return response.data;
}

export async function apiGetRelatedWord(info: GetRelatedWordParamType) {
  const paramsData: GetRelatedWordParamType = {
    word: info.word,
  };
  const response = await axios.get<GetRelatedWordType>(
    `${apiInfo.api_url}/related_word/`,
    {
      params: paramsData,
    }
  );

  return response.data;
}

export async function apiGetPopularKeyword(info: GetPopularKeywordParamType) {
  const paramsData: GetPopularKeywordParamType = {
    date_unit: info.date_unit,
    count: info.count,
  };
  const response = await axios.get<GetPopularKeywordType>(
    `${apiInfo.api_url}/popular/`,
    {
      params: paramsData,
    }
  );

  return response.data;
}

export async function apiGetWiki(info: GetWikiParamType) {
  const paramsData: GetWikiParamType = {
    query: info.query,
  };
  const response = await axios.get<GetWikiType>(
    `${apiInfo.api_url}/knowledge_graph/wiki/`,
    {
      params: paramsData,
    }
  );

  return response.data;
}

export async function apiGetSpellchecker(info: GetSpellCheckerParamType) {
  const paramsData: GetSpellCheckerParamType = {
    word: info.word,
  };
  const response = await axios.get<GetSpellCheckerType>(
    `${apiInfo.api_url}/suggest/spellchecker/`,
    {
      params: paramsData,
    }
  );
  return response.data;
}

export async function apiGetSearchImage(info: GetSearchImageParamType) {
  const paramsData: GetSearchImageParamType = {
    page: info.page,
    page_count: info.page_count,
    query: info.query,
    targets: info.targets,
    type: info.type,
  };
  const response = await axios.get<GetSearchImageType>(
    `${apiInfo.api_url}/search_image/`,
    {
      params: paramsData,
    }
  );
  return response.data;
}

export async function apiGetSearchAttach(info: GetSearchAttachParamType) {
  const paramsData: GetSearchAttachParamType = {
    page: info.page,
    page_count: info.page_count,
    query: info.query,
    targets: info.targets,
    type: info.type,
  };
  const response = await axios.get<GetSearchAttachResponseType>(
    `${apiInfo.api_url}/search_attach/`,
    {
      params: paramsData,
    }
  );
  return response.data;
}
